import React from 'react'
import {ProfileInfoQuery} from '../../organism'
import ProfileStyled from './styled'

const Profile = () => {
  return (
    <ProfileStyled>
      <ProfileInfoQuery />
    </ProfileStyled>
  )
}

export default Profile
